import { Button, Typography } from "@fullscript/aviary-web";
import { faArrowLeft } from "@fullscript/pro-regular-svg-icons";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { ConnectHeader } from "@unauthenticated/signupSignin/components/ConnectHeader/ConnectHeader";
import { l } from "@unauthenticated/signupSignin/locales/i18n";

import * as styles from "./ConnectPageLayout.styles";

interface Props {
  signInHref: string;
  onBackClick: () => void;
  sidebar: ReactNode;
  children: ReactNode;
}

const ConnectPageLayout = ({ signInHref, onBackClick, sidebar, children }: Props) => {
  const { t } = useTranslation();

  return (
    <div css={styles.page}>
      <ConnectHeader signInHref={signInHref} />
      <main css={styles.content}>
        <div css={styles.pageHead}>
          <Button
            variant="tertiary"
            size="small"
            leftIcon={faArrowLeft}
            onClick={onBackClick}
            customCss={styles.backButton}
          >
            {t(l.connect.pageHead.backToProfile)}
          </Button>
          <Typography variant="callout" fontWeight="bold" isMarginless customCss={styles.eyebrow}>
            {t(l.connect.pageHead.eyebrow)}
          </Typography>
          <Typography as="h1" variant="h1" colorIntensity="bold" isMarginless>
            {t(l.connect.pageHead.title)}
          </Typography>
        </div>
        <div css={styles.columns}>
          <div>{children}</div>
          <div css={styles.sideColumn}>{sidebar}</div>
        </div>
      </main>
    </div>
  );
};

export { ConnectPageLayout };
export type { Props as ConnectPageLayoutProps };
